export const UPGRADE_CONFIG = {
  BYPASS_MIN_VERSION_CHECK: false,
  ALLOW_SAME_VERSION_UPGRADE: true,
} as const;

export const BYPASS_MIN_VERSION = UPGRADE_CONFIG.BYPASS_MIN_VERSION_CHECK;
export const ALLOW_SAME_VERSION = UPGRADE_CONFIG.ALLOW_SAME_VERSION_UPGRADE;
